(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wos-aperoelchen-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function clone(id) {
      var template = document.getElementById(id);
      return template && template.content ? template.content.firstElementChild.cloneNode(true) : null;
    }

    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function enhanceHeader(root) {
      var productSection = root.querySelector('.product-section');
      var title = root.querySelector('.product-single__title');
      var header = title && title.closest('.product-block--header');
      if (productSection) productSection.id = 'aperoelchen-personalisieren';
      if (!title || !header) return;
      setText(title, 'Euer offizielles Aperölchen-Club-Shirt');
      if (!header.querySelector('.wos-apero-header-copy')) {
        var copy = clone('wos-apero-header-template');
        if (copy) title.insertAdjacentElement('afterend', copy);
      }
    }

    function enhanceConfigurator(root) {
      var form = root.querySelector('#tee-artwork-form');
      if (!form) return;

      var products = form.querySelector('.tee-available-products');
      if (products) {
        setText(products.querySelector('.tee-option__title'), 'Wähle deinen Schnitt');
        if (!products.querySelector('.wos-apero-fit-hints')) {
          var fit = clone('wos-apero-fit-template');
          if (fit) products.insertAdjacentElement('beforeend', fit);
        }
      }

      var colorLabel = form.querySelector('.tee-option--color .tee-radio-label span');
      var colorRadioLabel = form.querySelector('.tee-option--color .tee-radio-label');
      setText(colorLabel, 'Weiß');
      if (colorRadioLabel) colorRadioLabel.setAttribute('title', 'Weiß');

      var size = form.querySelector('.tee-option--size');
      if (size && !size.querySelector('.wos-apero-size-help')) {
        var sizeHelp = clone('wos-apero-size-template');
        if (sizeHelp) size.insertAdjacentElement('beforeend', sizeHelp);
      }

      var firstPersonalField = form.querySelector('.tee-field--layer-793921');
      if (firstPersonalField && !form.querySelector('.wos-apero-personalization-intro')) {
        var intro = clone('wos-apero-personalization-template');
        if (intro) firstPersonalField.insertAdjacentElement('beforebegin', intro);
      }

      var fields = [
        { selector: '#layer-793921', label: 'Dein Name', placeholder: 'z. B. Sabine' },
        { selector: '#layer-381269', label: 'Euer Club-Jahr', placeholder: 'z. B. 1995' },
        { selector: '#layer-310390', label: 'Eure Stadt', placeholder: 'z. B. Köln' }
      ];
      fields.forEach(function (field) {
        var input = form.querySelector(field.selector);
        var wrapper = input && input.closest('.tee-field');
        var label = wrapper && wrapper.querySelector('.tee-field__heading > span:first-child');
        setText(label, field.label);
        if (input) input.setAttribute('placeholder', field.placeholder);
      });

      var warning = form.querySelector('.tee-maxlength-warning');
      setText(warning, 'Bitte keine Emojis verwenden. Umlaute wie Ä, Ö und Ü in der Vorschau sorgfältig prüfen.');
    }

    function enhanceOffer(root) {
      var offer = root.querySelector('[data-wos-combi-offer-teeinblue]');
      if (!offer) return;
      setText(offer.querySelector('strong'), 'Euer Club, euer Vorteil');
      setText(offer.querySelector('.wos-combi-offer__copy span'), 'Ab 2 Artikeln erhältst du automatisch 10 % Kombi-Vorteil. Für unterschiedliche Namen personalisierst du jedes Shirt einzeln und legst es nacheinander in den Warenkorb.');
    }

    function enhanceActions(root) {
      var actions = root.querySelector('#teeFormActions');
      if (!actions) return;
      var preview = actions.querySelector('.tee-btn--preview');
      var atc = actions.querySelector('#teeAtcButton span');
      setText(preview, 'Design-Vorschau prüfen');
      if (preview) preview.setAttribute('aria-label', 'Design-Vorschau prüfen');
      setText(atc, 'Personalisiertes Shirt in den Warenkorb');

      var atcWrapper = actions.querySelector('.tee-form-atc-wrapper');
      if (atcWrapper && !atcWrapper.querySelector('.wos-apero-preview-status')) {
        var status = document.createElement('div');
        status.className = 'wos-apero-preview-status';
        status.setAttribute('aria-live', 'polite');
        status.textContent = 'Vorschau aktualisiert – bitte prüfe jetzt Namen, Stadt und Jahr im Produktbild.';
        atcWrapper.insertBefore(status, atcWrapper.firstChild);
      }

      if (preview && !preview.hasAttribute('data-wos-apero-listener')) {
        preview.setAttribute('data-wos-apero-listener', 'true');
        preview.addEventListener('click', function () {
          var status = actions.querySelector('.wos-apero-preview-status');
          if (status) status.classList.add('is-visible');
        });
      }

      if (!root.querySelector('[data-wos-apero-purchase-trust]')) {
        var trust = clone('wos-apero-trust-template');
        if (trust) actions.insertAdjacentElement('afterend', trust);
      }
    }

    function enhance() {
      enhanceHeader(document);
      enhanceConfigurator(document);
      enhanceOffer(document);
      enhanceActions(document);
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        enhance();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      enhance();
      var productSection = document.querySelector('.product-section');
      if (productSection) {
        new MutationObserver(schedule).observe(productSection, { childList: true, subtree: true });
        productSection.addEventListener('change', function () {
          window.setTimeout(schedule, 80);
        });
      }
    });
    document.addEventListener('teeinblue-event-component-injected', schedule);
    document.addEventListener('shopify:section:load', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-bierchen-delivery-estimate"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sourceSelector = '[data-wos-delivery-source]';
    const controllers = new Set();

    const parseLocalDate = (value) => {
      const parts = String(value || '').split('-').map(Number);
      if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) return new Date();
      return new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0, 0);
    };

    const addCalendarDays = (date, days) => {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    };

    const toIsoDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const getEasterSunday = (year) => {
      const a = year % 19;
      const b = Math.floor(year / 100);
      const c = year % 100;
      const d = Math.floor(b / 4);
      const e = b % 4;
      const f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4);
      const k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(year, month - 1, day, 12, 0, 0, 0);
    };

    const getGermanNationalHolidays = (year) => {
      const easter = getEasterSunday(year);
      return new Set([
        `${year}-01-01`,
        toIsoDate(addCalendarDays(easter, -2)),
        toIsoDate(addCalendarDays(easter, 1)),
        `${year}-05-01`,
        toIsoDate(addCalendarDays(easter, 39)),
        toIsoDate(addCalendarDays(easter, 50)),
        `${year}-10-03`,
        `${year}-12-25`,
        `${year}-12-26`
      ]);
    };

    const getExcludedDates = (startYear, endYear, customDates) => {
      const dates = new Set();
      for (let year = startYear; year <= endYear; year += 1) {
        getGermanNationalHolidays(year).forEach((date) => dates.add(date));
      }
      String(customDates || '')
        .split(/[\s,;]+/)
        .filter((date) => /^\d{4}-\d{2}-\d{2}$/.test(date))
        .forEach((date) => dates.add(date));
      return dates;
    };

    const addWorkdays = (date, count, excludedDates) => {
      const result = new Date(date);
      let added = 0;
      while (added < count) {
        result.setDate(result.getDate() + 1);
        const weekday = result.getDay();
        if (weekday !== 0 && weekday !== 6 && !excludedDates.has(toIsoDate(result))) added += 1;
      }
      return result;
    };

    const updateRange = (card, config) => {
      const range = card.querySelector('[data-wos-delivery-range]');
      if (!range) return;

      const today = parseLocalDate(config.today);
      const firstCount = Math.max(1, Number.parseInt(config.minWorkdays, 10) || 3);
      const lastCount = Math.max(firstCount, Number.parseInt(config.maxWorkdays, 10) || 5);
      const excludedDates = getExcludedDates(today.getFullYear(), today.getFullYear() + 2, config.excludedDates);
      const firstDate = addWorkdays(today, firstCount, excludedDates);
      const lastDate = addWorkdays(today, lastCount, excludedDates);
      const includeYear = firstDate.getFullYear() !== lastDate.getFullYear();
      const visibleFormatter = new Intl.DateTimeFormat('de-DE', {
        day: 'numeric',
        month: 'short',
        ...(includeYear ? { year: 'numeric' } : {})
      });
      const accessibleFormatter = new Intl.DateTimeFormat('de-DE', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
      const firstTime = document.createElement('time');
      const lastTime = document.createElement('time');

      firstTime.dateTime = toIsoDate(firstDate);
      firstTime.textContent = visibleFormatter.format(firstDate);
      lastTime.dateTime = toIsoDate(lastDate);
      lastTime.textContent = visibleFormatter.format(lastDate);

      range.replaceChildren(firstTime, document.createTextNode(' – '), lastTime);
      range.setAttribute(
        'aria-label',
        `${config.deliveryPrefix || 'Voraussichtliche Lieferung'} ${accessibleFormatter.format(firstDate)} bis ${accessibleFormatter.format(lastDate)}`
      );
    };

    const createController = (source) => {
      if (source.dataset.wosDeliveryInitialized === 'true') return null;
      const card = source.querySelector('[data-wos-delivery-card]');
      const configElement = source.querySelector('[data-wos-delivery-config]');
      if (!card || !configElement) return null;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return null;
      }

      source.dataset.wosDeliveryInitialized = 'true';
      updateRange(card, config);

      const hero = document.querySelector('.wos-anti-stress-product');
      let frame = 0;

      const mount = () => {
        frame = 0;
        if (!source.isConnected) return;
        const price = hero && hero.querySelector('.tee-product-price');

        if (price && price.parentElement) {
          if (card.previousElementSibling !== price || card.parentElement !== price.parentElement) {
            price.insertAdjacentElement('afterend', card);
          }
          source.hidden = true;
          return;
        }

        if (!card.isConnected) source.insertBefore(card, configElement);
        source.hidden = false;
      };

      const scheduleMount = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(mount);
      };

      const observer = hero ? new MutationObserver(scheduleMount) : null;
      if (observer) observer.observe(hero, { childList: true, subtree: true });
      scheduleMount();

      const controller = {
        sectionId: source.dataset.sectionId,
        source,
        card,
        scheduleMount,
        destroy() {
          if (frame) window.cancelAnimationFrame(frame);
          if (observer) observer.disconnect();
          card.remove();
          controllers.delete(controller);
        }
      };
      controllers.add(controller);
      return controller;
    };

    const initialize = (root = document) => {
      if (root.matches && root.matches(sourceSelector)) createController(root);
      root.querySelectorAll(sourceSelector).forEach(createController);
    };

    initialize();

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      controllers.forEach((controller) => {
        if (event.target.contains(controller.source) || event.target.dataset.sectionId === controller.sectionId) {
          controller.destroy();
        }
      });
    });
    window.addEventListener('pageshow', () => {
      initialize();
      controllers.forEach((controller) => controller.scheduleMount());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-bierchen-size-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-wos-bierchen-size-guide]';
    const mountedAttribute = 'data-wos-bierchen-size-mounted';
    const states = new Map();

    const normalize = (value) => (value || '')
      .toLocaleLowerCase('de-DE')
      .replace(/\s+/g, ' ')
      .trim();

    const findSizeField = (productRoot, targetLabel) => {
      const fields = Array.from(productRoot.querySelectorAll('.tee-field, .tee-option'));
      const labelMatch = fields.find((field) => {
        const label = field.querySelector('legend, .tee-field__heading, .tee__heading, .tee-field__label, .tee-label, .tee-option__title');
        return label && normalize(label.textContent).includes(targetLabel);
      });

      if (labelMatch) return labelMatch;

      return fields.find((field) => {
        const labels = Array.from(field.querySelectorAll('label')).map((label) => normalize(label.textContent));
        return labels.includes('s') && labels.includes('m') && labels.includes('l');
      }) || null;
    };

    const getModelFromText = (value) => {
      const selectedText = normalize(value);
      if (selectedText.includes('tasse')) return 'none';
      if (selectedText.includes('damen')) return 'women';
      if (selectedText.includes('hoodie')) return 'hoodie';
      return 'unisex';
    };

    const getInitialModel = (productRoot) => {
      const productField = productRoot.querySelector('.tee-field--teeinblue-available-prod');
      const checked = productField?.querySelector('input:checked');
      const labels = productField ? Array.from(productField.querySelectorAll('label')) : [];
      const selectedLabel = checked
        ? labels.find((label) => label.htmlFor === checked.id) || checked.nextElementSibling
        : null;
      return getModelFromText(selectedLabel?.textContent);
    };

    const syncPanel = (panel, selectedModel) => {
      if (!panel) return;
      panel.hidden = selectedModel === 'none';
      panel.querySelectorAll('[data-size-model]').forEach((table) => {
        table.hidden = table.dataset.sizeModel !== selectedModel;
      });
    };

    const init = (root) => {
      if (!root || states.has(root)) return;

      const sourcePanel = root.querySelector('.wos-bierchen-size-guide__panel');
      const targetLabel = normalize(root.dataset.targetLabel || 'Größe');
      const productRoot = document.querySelector('.wos-anti-stress-product [data-section-type="product"]');
      if (!sourcePanel || !productRoot) return;

      const state = { frame: null, observer: null, selectedModel: null };

      const mount = () => {
        state.frame = null;
        if (window.Shopify && window.Shopify.designMode) return;

        const field = findSizeField(productRoot, targetLabel);
        if (!field) {
          root.classList.remove('is-mounted');
          return;
        }

        if (!field.querySelector('[' + mountedAttribute + ']')) {
          const clone = sourcePanel.cloneNode(true);
          clone.setAttribute(mountedAttribute, 'true');
          clone.removeAttribute('open');
          field.appendChild(clone);
        }

        if (!state.selectedModel) state.selectedModel = getInitialModel(productRoot);
        syncPanel(field.querySelector('[' + mountedAttribute + ']'), state.selectedModel);

        root.classList.add('is-mounted');
      };

      const schedule = () => {
        if (state.frame) return;
        state.frame = window.requestAnimationFrame(mount);
      };

      state.observer = new MutationObserver((mutations) => {
        const relevant = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => (
          node.nodeType === 1 && (
            node.matches('.tee-field, .tee-option, .tee-form-wrapper') ||
            node.querySelector('.tee-field, .tee-option, .tee-form-wrapper')
          )
        )));
        if (relevant) schedule();
      });
      state.observer.observe(productRoot, { childList: true, subtree: true });

      const onTeeInjected = () => schedule();
      const onProductInteraction = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const productField = target.closest('.tee-field--teeinblue-available-prod');
        if (!productField) return;
        const label = target.closest('label') || Array.from(productField.querySelectorAll('label')).find((item) => item.htmlFor === target.id);
        if (!label) return;
        state.selectedModel = getModelFromText(label.textContent);
        schedule();
      };

      root.__wosBierchenSizeDestroy = () => {
        state.observer.disconnect();
        if (state.frame) window.cancelAnimationFrame(state.frame);
        document.removeEventListener('teeinblue-event-component-injected', onTeeInjected);
        productRoot.removeEventListener('click', onProductInteraction, true);
        productRoot.removeEventListener('change', onProductInteraction, true);
        states.delete(root);
      };

      states.set(root, state);
      schedule();
      document.addEventListener('teeinblue-event-component-injected', onTeeInjected);
      productRoot.addEventListener('click', onProductInteraction, true);
      productRoot.addEventListener('change', onProductInteraction, true);
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(selector)) init(scope);
      scope.querySelectorAll(selector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector(selector);
      if (root && root.__wosBierchenSizeDestroy) root.__wosBierchenSizeDestroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-mug-animal-filter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__wosMugAnimalFilterLoaded) return;
    window.__wosMugAnimalFilterLoaded = true;

    const markerSelector = '[data-wos-mug-animal-filter]';
    const instances = new Map();

    const normalize = (value) => String(value || '')
      .normalize('NFC')
      .toLocaleLowerCase('de-DE')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    const normalizeLoose = (value) => normalize(value)
      .replace(/ae/g, 'a')
      .replace(/oe/g, 'o')
      .replace(/ue/g, 'u');

    const elementFromNode = (node) => {
      if (!node) return null;
      return node.nodeType === 1 ? node : node.parentElement;
    };

    const getFieldLabel = (field) => {
      const label = field.querySelector(
        ':scope > .tee-field__label, :scope > .tee-field__heading, :scope > .tee-label, :scope > legend, ' +
        ':scope > * > .tee-field__label, :scope > * > .tee-field__heading'
      );
      return normalize(label ? label.textContent.replace(/\*/g, '') : '');
    };

    const getItems = (field) => Array.from(field.querySelectorAll('.tee-clipart-col'))
      .filter((item) => item.querySelector('.tee-clipart input[type="radio"]'));

    const getItemName = (item) => {
      const text = item.querySelector('.tee-clipart-label__text');
      if (text && text.textContent.trim()) return text.textContent.trim();

      const image = item.querySelector('.tee-clipart-thumbnail[alt], img[alt]');
      if (image && image.getAttribute('alt')) return image.getAttribute('alt').trim();

      const label = item.querySelector('label');
      return label ? label.textContent.trim() : '';
    };

    const restoreItems = (field) => {
      if (!field) return;
      field.querySelectorAll('[data-wos-animal-hidden="true"]').forEach((item) => {
        item.removeAttribute('data-wos-animal-hidden');
        item.removeAttribute('hidden');
      });
    };

    const findField = (state) => {
      const candidates = Array.from(state.mainProduct.querySelectorAll(
        '#tee-artwork-form .tee-field--clipart'
      ));

      if (!candidates.length) return null;

      const target = normalize(state.marker.dataset.targetFieldLabel);
      if (target) {
        const exact = candidates.find((field) => getFieldLabel(field) === target);
        if (exact) return exact;
      }

      return candidates.length === 1 ? candidates[0] : null;
    };

    const createSvg = () => {
      const namespace = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(namespace, 'svg');
      const circle = document.createElementNS(namespace, 'circle');
      const path = document.createElementNS(namespace, 'path');

      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      circle.setAttribute('cx', '11');
      circle.setAttribute('cy', '11');
      circle.setAttribute('r', '7');
      circle.setAttribute('stroke', 'currentColor');
      circle.setAttribute('stroke-width', '1.8');
      path.setAttribute('d', 'm16.2 16.2 4 4');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.8');
      path.setAttribute('stroke-linecap', 'round');
      svg.append(circle, path);
      return svg;
    };

    const applyStyles = (state, ui) => {
      const values = {
        '--wos-animal-bg': state.marker.dataset.backgroundColor,
        '--wos-animal-input-bg': state.marker.dataset.inputBackgroundColor,
        '--wos-animal-text': state.marker.dataset.textColor,
        '--wos-animal-muted': state.marker.dataset.mutedColor,
        '--wos-animal-border': state.marker.dataset.borderColor,
        '--wos-animal-focus': state.marker.dataset.focusColor,
        '--wos-animal-radius': state.marker.dataset.radius
      };

      Object.entries(values).forEach(([property, value]) => {
        if (value) ui.style.setProperty(property, value);
      });
    };

    const buildUi = (state) => {
      const ui = document.createElement('div');
      const label = document.createElement('label');
      const control = document.createElement('div');
      const icon = document.createElement('span');
      const input = document.createElement('input');
      const clear = document.createElement('button');
      const status = document.createElement('p');
      const empty = document.createElement('div');
      const emptyTitle = document.createElement('p');
      const emptyCopy = document.createElement('p');
      const ownerId = state.marker.dataset.ownerId;

      ui.className = 'wos-animal-finder';
      ui.dataset.wosAnimalFinder = ownerId;
      label.className = 'wos-animal-finder__label';
      label.htmlFor = `WosAnimalSearch-${ownerId}`;
      label.textContent = state.marker.dataset.heading;
      control.className = 'wos-animal-finder__control';
      icon.className = 'wos-animal-finder__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.append(createSvg());

      input.id = `WosAnimalSearch-${ownerId}`;
      input.className = 'wos-animal-finder__input';
      input.type = 'search';
      input.placeholder = state.marker.dataset.placeholder;
      input.autocomplete = 'off';
      input.spellcheck = false;
      input.setAttribute('enterkeyhint', 'search');
      input.setAttribute('inputmode', 'search');
      input.value = state.term;

      clear.className = 'wos-animal-finder__clear';
      clear.type = 'button';
      clear.setAttribute('aria-label', state.marker.dataset.clearLabel);
      clear.textContent = '×';
      clear.hidden = !state.term.trim();

      status.className = 'wos-animal-finder__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');

      empty.className = 'wos-animal-finder__empty';
      empty.hidden = true;
      emptyTitle.className = 'wos-animal-finder__empty-title';
      emptyTitle.textContent = state.marker.dataset.noResultsHeading;
      emptyCopy.className = 'wos-animal-finder__empty-copy';
      emptyCopy.textContent = state.marker.dataset.noResultsCopy;
      empty.append(emptyTitle, emptyCopy);

      if (
        state.marker.dataset.showRequestLink === 'true' &&
        state.marker.dataset.requestUrl &&
        state.marker.dataset.requestLabel
      ) {
        const requestLink = document.createElement('a');
        requestLink.className = 'wos-animal-finder__request';
        requestLink.href = state.marker.dataset.requestUrl;
        requestLink.textContent = state.marker.dataset.requestLabel;
        empty.append(requestLink);
      }

      control.append(icon, input, clear);
      ui.append(label, control, status, empty);
      applyStyles(state, ui);

      state.uiAbort = new AbortController();
      input.addEventListener('input', () => {
        state.term = input.value;
        scheduleFilter(state);
      }, { signal: state.uiAbort.signal });
      input.addEventListener('search', () => {
        state.term = input.value;
        scheduleFilter(state);
      }, { signal: state.uiAbort.signal });
      clear.addEventListener('click', () => {
        input.value = '';
        state.term = '';
        applyFilter(state);
        input.focus();
      }, { signal: state.uiAbort.signal });

      state.ui = ui;
      state.input = input;
      state.clear = clear;
      state.status = status;
      state.empty = empty;
      return ui;
    };

    const formatStatus = (state, visible, total, hasQuery) => {
      if (!hasQuery) return `${total} ${state.marker.dataset.statusAll}`;
      const label = visible === 1
        ? state.marker.dataset.statusSingular
        : state.marker.dataset.statusPlural;
      return `${visible} ${label}`;
    };

    const applyFilter = (state) => {
      state.filterFrame = null;
      if (!state.field || !state.field.isConnected || !state.ui || !state.ui.isConnected) return;

      try {
        const items = getItems(state.field);
        const trimmedTerm = state.term.trim();
        const query = normalize(trimmedTerm);
        const looseQuery = normalizeLoose(trimmedTerm);
        let visible = 0;

        items.forEach((item) => {
          const name = getItemName(item);
          const key = normalize(name);
          const looseKey = normalizeLoose(name);
          const matches = !query || key.includes(query) || looseKey.includes(looseQuery);

          if (matches) {
            item.removeAttribute('data-wos-animal-hidden');
            item.removeAttribute('hidden');
            visible += 1;
          } else {
            item.dataset.wosAnimalHidden = 'true';
            item.hidden = true;
          }
        });

        state.clear.hidden = !trimmedTerm;
        state.empty.hidden = !trimmedTerm || visible > 0;
        state.status.textContent = formatStatus(state, visible, items.length, Boolean(trimmedTerm));
      } catch (error) {
        restoreItems(state.field);
        if (state.ui) state.ui.remove();
        state.ui = null;
      }
    };

    const scheduleFilter = (state) => {
      if (state.filterFrame) return;
      state.filterFrame = window.requestAnimationFrame(() => applyFilter(state));
    };

    const detachUi = (state) => {
      if (state.filterFrame) window.cancelAnimationFrame(state.filterFrame);
      state.filterFrame = null;
      if (state.uiAbort) state.uiAbort.abort();
      restoreItems(state.field);
      if (state.ui) state.ui.remove();
      state.uiAbort = null;
      state.ui = null;
      state.input = null;
      state.clear = null;
      state.status = null;
      state.empty = null;
      state.field = null;
    };

    const mount = (state, field) => {
      const row = field.querySelector('.tee-clipart-row');
      if (!row || !getItems(field).length) return false;

      const existing = field.querySelector('.wos-animal-finder');
      if (existing) existing.remove();

      state.field = field;
      const ui = buildUi(state);
      row.insertAdjacentElement('beforebegin', ui);
      applyFilter(state);
      return true;
    };

    const reconcile = (state) => {
      state.reconcileFrame = null;
      if (!state.marker.isConnected || !state.mainProduct.isConnected) return;

      const field = findField(state);
      if (!field) {
        if (state.field && !state.field.isConnected) detachUi(state);
        return;
      }

      if (state.field !== field || !state.ui || !state.ui.isConnected) {
        detachUi(state);
        mount(state, field);
        return;
      }

      scheduleFilter(state);
    };

    const scheduleReconcile = (state) => {
      if (state.reconcileFrame) return;
      state.reconcileFrame = window.requestAnimationFrame(() => reconcile(state));
    };

    const mutationIsRelevant = (mutation) => {
      const target = elementFromNode(mutation.target);
      if (target && target.closest('#teeFormInputs .tee-field--clipart')) return true;

      return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some((node) => {
        const element = elementFromNode(node);
        if (!element) return false;
        return element.matches?.('.tee-field--clipart, .tee-clipart-row, .tee-clipart-col') ||
          element.querySelector?.('.tee-field--clipart, .tee-clipart-row, .tee-clipart-col');
      });
    };

    const init = (marker) => {
      if (!marker || instances.has(marker)) return;

      const mainProduct = document.querySelector('#MainContent [data-section-type="product"]');
      if (!mainProduct) return;

      const state = {
        marker,
        mainProduct,
        field: null,
        ui: null,
        input: null,
        clear: null,
        status: null,
        empty: null,
        term: '',
        filterFrame: null,
        reconcileFrame: null,
        uiAbort: null,
        lifecycleAbort: new AbortController(),
        observer: null
      };

      const schedule = () => scheduleReconcile(state);
      document.addEventListener('teeinblue-event-component-injected', schedule, {
        signal: state.lifecycleAbort.signal
      });
      window.addEventListener('pageshow', schedule, { signal: state.lifecycleAbort.signal });
      window.addEventListener('popstate', schedule, { signal: state.lifecycleAbort.signal });

      state.observer = new MutationObserver((mutations) => {
        if (mutations.some(mutationIsRelevant)) scheduleReconcile(state);
      });
      state.observer.observe(mainProduct, { childList: true, subtree: true });

      instances.set(marker, state);
      scheduleReconcile(state);
    };

    const destroy = (marker) => {
      const state = instances.get(marker);
      if (!state) return;

      if (state.observer) state.observer.disconnect();
      if (state.lifecycleAbort) state.lifecycleAbort.abort();
      if (state.reconcileFrame) window.cancelAnimationFrame(state.reconcileFrame);
      detachUi(state);
      instances.delete(marker);
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(markerSelector)) init(scope);
      scope.querySelectorAll(markerSelector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const marker = event.target.matches?.(markerSelector)
        ? event.target
        : event.target.querySelector?.(markerSelector);
      if (marker) destroy(marker);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-mug-faq"] && !Shopify.designMode) return;
  try {
    
  const initWosMugFaq = (scope = document) => {
    scope.querySelectorAll('[data-wos-mug-faq]').forEach((faq) => {
      if (faq.dataset.wosFaqReady === 'true') return;
      faq.dataset.wosFaqReady = 'true';

      faq.querySelectorAll('details').forEach((item) => {
        const summary = item.querySelector('summary');
        if (!summary) return;

        const syncExpandedState = () => {
          summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
        };

        item.addEventListener('toggle', syncExpandedState);
        syncExpandedState();
      });
    });
  };

  initWosMugFaq();
  document.addEventListener('shopify:section:load', (event) => initWosMugFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-mug-sticky-purchase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-wos-mug-sticky-purchase]';
    const mobileQuery = window.matchMedia('(max-width: 768px)');
    const instances = new Map();

    const isRendered = (element) => {
      if (!element || !element.getClientRects().length) return false;

      const styles = window.getComputedStyle(element);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    };

    const init = (root) => {
      if (!root || instances.has(root)) return;

      const action = root.querySelector('[data-wos-mug-sticky-action]');
      const price = root.querySelector('[data-wos-mug-sticky-price]');
      const mainProduct = document.querySelector('.wos-anti-stress-product [data-section-type="product"]');

      if (!action || !price || !mainProduct) return;

      const state = {
        root,
        action,
        price,
        mainProduct,
        primaryCta: null,
        personalization: null,
        ctaVisible: false,
        ctaPassed: false,
        frame: null,
        focusTimer: null,
        deferredTimers: [],
        observers: []
      };

      const getPersonalization = () => {
        const teeForm = state.mainProduct.querySelector('.tee-form-wrapper');
        if (isRendered(teeForm)) return teeForm;

        return state.mainProduct.querySelector('.product-single__form');
      };

      const getPrimaryCta = () => {
        const candidates = state.mainProduct.querySelectorAll(
          '.tee-form-wrapper .tee-btn--atc, .tee-btn--atc, .product-single__form [data-add-to-cart]'
        );

        return Array.from(candidates).find((candidate) => {
          const isOverlayButton = candidate.closest(
            '[role="dialog"], .tee-preview, .teeinblue-modal, .tee-modal, .tee-modal-wrapper'
          );
          return isRendered(candidate) && !isOverlayButton;
        }) || null;
      };

      const syncPrice = () => {
        const source = state.mainProduct.querySelector(
          '.tee-product-price .tee-price--current, [data-product-price], .wos-anti-stress-price__current'
        );

        if (!isRendered(source)) return;

        const value = source.textContent.replace(/\s+/g, ' ').trim();
        if (value && state.price.textContent.trim() !== value) {
          state.price.textContent = value;
        }
      };

      const hasEditableFocus = () => {
        const active = document.activeElement;
        return Boolean(
          active &&
          active.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]')
        );
      };

      const keyboardIsOpen = () => {
        if (!window.visualViewport || !hasEditableFocus()) return false;
        return window.visualViewport.height < window.innerHeight - 120;
      };

      const cartIsOpen = () => {
        const drawer = document.querySelector('#CartDrawer');
        return Boolean(drawer && drawer.classList.contains('drawer--is-open'));
      };

      const teeOverlayIsOpen = () => {
        const overlays = document.querySelectorAll(
          '.tee-preview, .teeinblue-modal, .tee-modal, .tee-modal-wrapper, .tee-popup, ' +
          '.tee-dialog, .tee-editor, .teeinblue-editor, ' +
          '[class*="tee"][role="dialog"], [role="dialog"] [class*="tee"]'
        );
        return Array.from(overlays).some(isRendered);
      };

      const update = () => {
        state.frame = null;
        state.personalization = getPersonalization();
        syncPrice();

        if (state.primaryCta) {
          const ctaRect = state.primaryCta.getBoundingClientRect();
          state.ctaVisible = ctaRect.bottom > 0 && ctaRect.top < window.innerHeight;
          state.ctaPassed = !state.ctaVisible && ctaRect.bottom <= 0;
        }

        const shouldShow = Boolean(
          mobileQuery.matches &&
          state.primaryCta &&
          state.ctaPassed &&
          !state.ctaVisible &&
          !cartIsOpen() &&
          !teeOverlayIsOpen() &&
          !hasEditableFocus() &&
          !keyboardIsOpen() &&
          document.visibilityState !== 'hidden'
        );

        state.root.classList.toggle('is-visible', shouldShow);
        state.root.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        if (shouldShow) {
          state.action.removeAttribute('tabindex');
        } else {
          state.action.setAttribute('tabindex', '-1');
        }
      };

      const scheduleUpdate = () => {
        if (state.frame) return;
        state.frame = window.requestAnimationFrame(update);
      };

      const observePrimaryCta = () => {
        const nextCta = getPrimaryCta();
        if (!nextCta || nextCta === state.primaryCta) return;

        state.primaryCta = nextCta;
        state.ctaVisible = false;
        state.ctaPassed = nextCta.getBoundingClientRect().bottom <= 0;
        state.intersectionObserver.disconnect();
        state.intersectionObserver.observe(nextCta);
        scheduleUpdate();
      };

      state.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target !== state.primaryCta) return;

          const rect = entry.boundingClientRect;
          state.ctaVisible = entry.isIntersecting && entry.intersectionRatio > 0;
          state.ctaPassed = !state.ctaVisible && rect.bottom <= 0;
        });
        scheduleUpdate();
      }, { threshold: [0, 0.01] });
      state.observers.push(state.intersectionObserver);

      const productObserver = new MutationObserver((mutations) => {
        const hooksMayHaveChanged = mutations.some((mutation) => {
          const element = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
          if (element && element.closest('.tee-product-price')) return true;

          return Array.from(mutation.addedNodes).some((node) => (
            node.nodeType === 1 && (
              node.matches('.tee-form-wrapper, .tee-btn--atc, .tee-product-price') ||
              node.querySelector('.tee-form-wrapper, .tee-btn--atc, .tee-product-price')
            )
          ));
        });

        if (hooksMayHaveChanged) {
          observePrimaryCta();
          scheduleUpdate();
        }
      });
      productObserver.observe(state.mainProduct, { childList: true, subtree: true, characterData: true });
      state.observers.push(productObserver);

      const rootObserver = new MutationObserver(scheduleUpdate);
      rootObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      state.observers.push(rootObserver);

      const cartDrawer = document.querySelector('#CartDrawer');
      if (cartDrawer) {
        const cartObserver = new MutationObserver(scheduleUpdate);
        cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
        state.observers.push(cartObserver);
      }

      const overlayObserver = new MutationObserver(scheduleUpdate);
      overlayObserver.observe(document.body, { childList: true, subtree: true });
      state.observers.push(overlayObserver);

      const onFocusChange = () => {
        window.clearTimeout(state.focusTimer);
        state.focusTimer = window.setTimeout(scheduleUpdate, 40);
      };

      const onPossibleOverlayChange = () => {
        state.deferredTimers.forEach((timer) => window.clearTimeout(timer));
        state.deferredTimers = [];
        scheduleUpdate();
        [80, 260, 600].forEach((delay) => {
          const timer = window.setTimeout(scheduleUpdate, delay);
          state.deferredTimers.push(timer);
        });
      };

      const onAction = () => {
        const target = getPersonalization();
        if (!target) return;

        state.root.classList.remove('is-visible');
        state.root.setAttribute('aria-hidden', 'true');
        state.action.setAttribute('tabindex', '-1');

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - 12;
        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });

        const focusTarget = Array.from(target.querySelectorAll(
          'input[type="text"], input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea, select'
        )).find(isRendered);

        if (focusTarget) {
          window.clearTimeout(state.focusTimer);
          state.focusTimer = window.setTimeout(() => {
            focusTarget.focus({ preventScroll: true });
            scheduleUpdate();
          }, reducedMotion ? 0 : 420);
        }
      };

      state.onFocusChange = onFocusChange;
      state.onPossibleOverlayChange = onPossibleOverlayChange;
      state.onAction = onAction;
      state.scheduleUpdate = scheduleUpdate;
      state.observePrimaryCta = observePrimaryCta;

      action.addEventListener('click', onAction);
      document.addEventListener('focusin', onFocusChange);
      document.addEventListener('focusout', onFocusChange);
      document.addEventListener('click', onPossibleOverlayChange, true);
      document.addEventListener('variant:change', scheduleUpdate);
      document.addEventListener('teeinblue-event-component-injected', observePrimaryCta);
      document.addEventListener('visibilitychange', scheduleUpdate);
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      mobileQuery.addEventListener('change', scheduleUpdate);

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
      }

      state.root.hidden = false;
      instances.set(root, state);
      observePrimaryCta();
      scheduleUpdate();
    };

    const destroy = (root) => {
      const state = instances.get(root);
      if (!state) return;

      state.observers.forEach((observer) => observer.disconnect());
      state.deferredTimers.forEach((timer) => window.clearTimeout(timer));
      window.clearTimeout(state.focusTimer);
      if (state.frame) window.cancelAnimationFrame(state.frame);

      state.action.removeEventListener('click', state.onAction);
      document.removeEventListener('focusin', state.onFocusChange);
      document.removeEventListener('focusout', state.onFocusChange);
      document.removeEventListener('click', state.onPossibleOverlayChange, true);
      document.removeEventListener('variant:change', state.scheduleUpdate);
      document.removeEventListener('teeinblue-event-component-injected', state.observePrimaryCta);
      document.removeEventListener('visibilitychange', state.scheduleUpdate);
      window.removeEventListener('scroll', state.scheduleUpdate);
      window.removeEventListener('resize', state.scheduleUpdate);
      mobileQuery.removeEventListener('change', state.scheduleUpdate);

      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', state.scheduleUpdate);
      }

      instances.delete(root);
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(selector)) init(scope);
      scope.querySelectorAll(selector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector(selector);
      if (root) destroy(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wos-weinchen-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function normalize(text) {
      return (text || '').replace(/\s+/g, ' ').trim();
    }

    function clone(id) {
      var template = document.getElementById(id);
      return template && template.content ? template.content.firstElementChild.cloneNode(true) : null;
    }

    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function enhanceHeader(root) {
      var section = root.querySelector('.product-section');
      var title = root.querySelector('.product-single__title');
      var header = title && title.closest('.product-block--header');
      if (section) section.id = 'weinchen-personalisieren';
      if (!title || !header) return;
      setText(title, 'Dein personalisiertes Weinchen-Club-Shirt');
      if (!header.querySelector('.wos-wine-header-copy')) {
        var copy = clone('wos-wine-header-template');
        if (copy) title.insertAdjacentElement('afterend', copy);
      }
    }

    function enhanceConfigurator(root) {
      var form = root.querySelector('#tee-artwork-form');
      if (!form) return;

      var products = form.querySelector('.tee-available-products');
      if (products) {
        setText(products.querySelector('.tee-option__title'), 'Wähle deinen Schnitt');
        if (!products.querySelector('.wos-wine-fit-hints')) {
          var fit = clone('wos-wine-fit-template');
          if (fit) products.insertAdjacentElement('beforeend', fit);
        }
      }

      var colorLabel = form.querySelector('.tee-option--color .tee-radio-label span');
      var colorRadioLabel = form.querySelector('.tee-option--color .tee-radio-label');
      setText(colorLabel, 'Weiß');
      if (colorRadioLabel) colorRadioLabel.setAttribute('title', 'Weiß');

      var size = form.querySelector('.tee-option--size');
      if (size && !size.querySelector('.wos-wine-size-help')) {
        var sizeHelp = clone('wos-wine-size-template');
        if (sizeHelp) size.insertAdjacentElement('beforeend', sizeHelp);
      }

      var firstPersonalField = form.querySelector('.tee-field--layer-850916');
      if (firstPersonalField && !form.querySelector('.wos-wine-personalization-intro')) {
        var intro = clone('wos-wine-personalization-template');
        if (intro) firstPersonalField.insertAdjacentElement('beforebegin', intro);
      }

      var fields = [
        { selector: '#layer-850916', label: 'Dein Name', placeholder: 'z. B. Sabine' },
        { selector: '#layer-343622', label: 'Dein Club-Jahr', placeholder: 'z. B. 1995' },
        { selector: '#layer-155590', label: 'Deine Stadt', placeholder: 'z. B. Köln' }
      ];
      fields.forEach(function (field) {
        var input = form.querySelector(field.selector);
        var wrapper = input && input.closest('.tee-field');
        var label = wrapper && wrapper.querySelector('.tee-field__heading > span:first-child');
        setText(label, field.label);
        if (input) input.setAttribute('placeholder', field.placeholder);
      });

      var warning = form.querySelector('.tee-maxlength-warning');
      setText(warning, 'Bitte keine Emojis verwenden. Umlaute wie Ä, Ö und Ü in der Vorschau sorgfältig prüfen.');
    }

    function enhanceOffer(root) {
      var offer = root.querySelector('[data-wos-combi-offer-teeinblue]');
      if (!offer) return;
      setText(offer.querySelector('strong'), '10 % Kombi-Vorteil ab 2 Artikeln');
      setText(offer.querySelector('.wos-combi-offer__copy span'), 'Bestellst du Shirts für mehrere Personen? Ab 2 Artikeln erhältst du automatisch 10 % Rabatt – jedes Shirt kann individuell personalisiert werden.');
    }

    function enhanceActions(root) {
      var actions = root.querySelector('#teeFormActions');
      if (!actions) return;
      var preview = actions.querySelector('.tee-btn--preview');
      var atc = actions.querySelector('#teeAtcButton span');
      setText(preview, 'Design-Vorschau prüfen');
      if (preview) preview.setAttribute('aria-label', 'Design-Vorschau prüfen');
      setText(atc, 'Personalisiertes Shirt in den Warenkorb');

      var atcWrapper = actions.querySelector('.tee-form-atc-wrapper');
      if (atcWrapper && !atcWrapper.querySelector('.wos-wine-preview-status')) {
        var status = document.createElement('div');
        status.className = 'wos-wine-preview-status';
        status.setAttribute('aria-live', 'polite');
        status.textContent = 'Vorschau aktualisiert – bitte prüfe jetzt Namen, Stadt und Jahr im Produktbild.';
        atcWrapper.insertBefore(status, atcWrapper.firstChild);
      }

      if (preview && !preview.hasAttribute('data-wos-wine-listener')) {
        preview.setAttribute('data-wos-wine-listener', 'true');
        preview.addEventListener('click', function () {
          var status = actions.querySelector('.wos-wine-preview-status');
          if (status) status.classList.add('is-visible');
        });
      }

      if (!root.querySelector('[data-wos-wine-purchase-trust]')) {
        var trust = clone('wos-wine-trust-template');
        if (trust) actions.insertAdjacentElement('afterend', trust);
      }
    }

    function enhance() {
      enhanceHeader(document);
      enhanceConfigurator(document);
      enhanceOffer(document);
      enhanceActions(document);
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        enhance();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      enhance();
      var product = document.querySelector('.product-section');
      if (product) {
        new MutationObserver(schedule).observe(product, { childList: true, subtree: true });
        product.addEventListener('change', function () {
          window.setTimeout(schedule, 80);
        });
      }
    });
    document.addEventListener('teeinblue-event-component-injected', schedule);
    document.addEventListener('shopify:section:load', schedule);
  })();

  } catch(e) { console.error(e); }
})();
})();
